import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PRODUCT_DEFAULT_PATH, ERROR_404_PATH } from '../constants/route.constants';

@Injectable({ providedIn: 'root' })
export class ProductGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    let authorize = JSON.parse(environment.authorizeProspectBrands) as string[];
    if (authorize.some(m => m == environment.brand)) this.router.navigate([PRODUCT_DEFAULT_PATH]);
    else this.router.navigate([ERROR_404_PATH]);

    // on retourne false pour bloquer l'accès à la route vide
    return false;
  }
}
